import ACM120 from 'assets/img/ACM-120.png';
import ACM140 from 'assets/img/ACM-140.png';
import ACM190 from 'assets/img/ACM-190.png';
import Gaposa120 from 'assets/img/Gaposa-120.png';
import Gaposa140 from 'assets/img/Gaposa-140.png';
import Gaposa190 from 'assets/img/Gaposa-190.png';
import { default as BoiteBip, default as BoiteBouton } from 'assets/img/boite-bouton.png';
import BoiteCleCableDebrayage from 'assets/img/boite-cle-cable-debrayage.png';
import BoiteCle from 'assets/img/boite-cle.png';
import MoteurCentrale from 'assets/img/rideau-moteur-centrale.png';
import MoteurLaterale from 'assets/img/rideau-moteur-laterale.png';
import MoteurTubulaire from 'assets/img/rideau-moteur-tubulaire.png';
import formInputsTypes from '../../simulatorConstant';
import RideauMetalliqueManuelCompletData from './manuel';
import { AxeMotoriseRM, BoiteRM, marqueMoteur } from '../data';
import droite from 'assets/img/stock/droite.png';
import gauche from 'assets/img/stock/gauche.png';
export const CATEG_ID_MOTEUR_RIDEAU = 36;

const sortie_cable = {
	id: 'MD',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie de câble (vue en face)',
	name: 'sortie_cable',
	className: 'col-6',
	classGroup: 'SProduit',
	nextStepData: RideauMetalliqueManuelCompletData,
	nextStep: false,
	options: [
		{
			id: 'gauche',
			value: 'gauche',
			label: 'Gauche',
			imageUrl: gauche,
			nextStep: false,
			description: '- Sortie de câble à gauche (vue de face).',
		},
		{
			id: 'droite',
			value: 'droite',
			label: 'Droite',
			imageUrl: droite,
			nextStep: false,
			description: '- Sortie de câble à droite (vue de face).',
		},
	],
};

const BoiteRMData = {
	id: 'BoiteRMData',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Boite',
	name: 'BoiteRMData',
	className: 'col-6',
	nextStepData: sortie_cable,
	nextStep: false,
		options: BoiteRM,
	
};

const puissance = {
	id: 'RM-PUISSANCE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Puissance moteur',
	name: 'puissance',
	className: 'col-12',
	nextStepData: BoiteRMData,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeMotorisation =
			currentFormValue?.values?.typeMotorisation?.value;
		const marque =
			currentFormValue?.values?.marque?.value || '';

		let puissances = [];

		switch (typeMotorisation) {
			case 'latéral':
				puissances = [220, 380, 400, 500, 750];
				break;

			case 'tubulaire':
				puissances = [250, 300, 400, 550, 650];
				break;

			case 'central triphasé':
				puissances = [250, 400, 550, 650, 1000];
				break;

			case 'central monophasé':
				puissances = [120, 140, 180, 190, 220];
				break;

			default:
				puissances = [];
		}

		const options = puissances.map((p) => ({
			id: String(p),
			label: `${p} Nm`,
			value: String(p),
			nextStep: false,
			description: `- Puissance moteur ${p} Nm ${marque}.` 

		}));

		fnSuccess(options);
	},
};
const marque = {
	id: 'RM-LAT-MARQUE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Marque',
	name: 'marque',
	className: 'col-12',
	nextStepData: puissance,
	nextStep: false,
	options: marqueMoteur
};
const RideauMetalliqueMotoriseCompletData = {
	id: 'AxeMotoriseRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Motorisation',
	name: 'typeMotorisation',
	className: 'col-6',
	nextStepData: marque,
	nextStep: false,
	options: AxeMotoriseRM
};


export default RideauMetalliqueMotoriseCompletData;
